import React, { useEffect } from 'react';
import { Controller, UseFormClearErrors } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import './DatePickerMUI.css'; // Import custom styles
import {
    FieldValues,
    UseFormWatch,
} from "react-hook-form";

interface DatePickerComponentProps {
    name: string;
    label: string;
    control: any;
    errors: any;
    placeholderText: string;
    watch: UseFormWatch<FieldValues>;
    clearErrors: UseFormClearErrors<FieldValues>;
    disabled?: boolean;
}

const CustomCalendarIcon = () => (
    <span className="custom-calendar-icon">
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.615 21C5.155 21 4.771 20.846 4.463 20.538C4.155 20.23 4.00067 19.8457 4 19.385V6.61502C4 6.15502 4.15433 5.77102 4.463 5.46302C4.77167 5.15502 5.15567 5.00069 5.615 5.00002H7.385V2.77002H8.462V5.00002H15.615V2.77002H16.615V5.00002H18.385C18.845 5.00002 19.229 5.15435 19.537 5.46302C19.845 5.77169 19.9993 6.15569 20 6.61502V19.385C20 19.845 19.846 20.229 19.538 20.537C19.23 20.845 18.8457 20.9994 18.385 21H5.615ZM5.615 20H18.385C18.5383 20 18.6793 19.936 18.808 19.808C18.9367 19.68 19.0007 19.539 19 19.385V10.615H5V19.385C5 19.5384 5.064 19.6794 5.192 19.808C5.32 19.9367 5.461 20.0007 5.615 20ZM5 9.61502H19V6.61502C19 6.46169 18.936 6.32069 18.808 6.19202C18.68 6.06335 18.539 5.99935 18.385 6.00002H5.615C5.46167 6.00002 5.32067 6.06402 5.192 6.19202C5.06333 6.32002 4.99933 6.46102 5 6.61502V9.61502ZM12 14.154C11.7933 14.154 11.6133 14.0774 11.46 13.924C11.3067 13.7707 11.23 13.5907 11.23 13.384C11.23 13.1774 11.3067 12.9977 11.46 12.845C11.6133 12.6924 11.7933 12.6157 12 12.615C12.2067 12.6144 12.3867 12.691 12.54 12.845C12.6933 12.999 12.77 13.179 12.77 13.385C12.77 13.591 12.6933 13.7707 12.54 13.924C12.3867 14.0774 12.2067 14.154 12 14.154ZM8 14.154C7.79333 14.154 7.61333 14.0774 7.46 13.924C7.30667 13.7707 7.23 13.5907 7.23 13.384C7.23 13.1774 7.30667 12.9977 7.46 12.845C7.61333 12.6924 7.79333 12.6157 8 12.615C8.20667 12.6144 8.38667 12.691 8.54 12.845C8.69333 12.999 8.77 13.179 8.77 13.385C8.77 13.591 8.69333 13.7707 8.54 13.924C8.38667 14.0774 8.20667 14.154 8 14.154ZM16 14.154C15.7933 14.154 15.6133 14.0774 15.46 13.924C15.3067 13.7707 15.23 13.5907 15.23 13.384C15.23 13.1774 15.3067 12.9977 15.46 12.845C15.6133 12.6924 15.7933 12.6157 16 12.615C16.2067 12.6144 16.3867 12.691 16.54 12.845C16.6933 12.999 16.77 13.179 16.77 13.385C16.77 13.591 16.6933 13.7707 16.54 13.924C16.3867 14.0774 16.2067 14.154 16 14.154ZM12 18C11.7933 18 11.6133 17.9234 11.46 17.77C11.3067 17.6167 11.23 17.4367 11.23 17.23C11.23 17.0234 11.3067 16.8437 11.46 16.691C11.6133 16.5384 11.7933 16.4617 12 16.461C12.2067 16.4604 12.3867 16.537 12.54 16.691C12.6933 16.845 12.77 17.025 12.77 17.231C12.77 17.437 12.6933 17.617 12.54 17.771C12.3867 17.925 12.2067 18.0014 12 18ZM8 18C7.79333 18 7.61333 17.9234 7.46 17.77C7.30667 17.6167 7.23 17.4367 7.23 17.23C7.23 17.0234 7.30667 16.8437 7.46 16.691C7.61333 16.5384 7.79333 16.4617 8 16.461C8.20667 16.4604 8.38667 16.537 8.54 16.691C8.69333 16.845 8.77 17.025 8.77 17.231C8.77 17.437 8.69333 17.617 8.54 17.771C8.38667 17.925 8.20667 18.0014 8 18ZM16 18C15.7933 18 15.6133 17.9234 15.46 17.77C15.3067 17.6167 15.23 17.4367 15.23 17.23C15.23 17.0234 15.3067 16.8437 15.46 16.691C15.6133 16.5384 15.7933 16.4617 16 16.461C16.2067 16.4604 16.3867 16.537 16.54 16.691C16.6933 16.845 16.77 17.025 16.77 17.231C16.77 17.437 16.6933 17.617 16.54 17.771C16.3867 17.925 16.2067 18.0014 16 18Z"
                fill="black"
            />
        </svg>
    </span>
);
const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
    name,
    label,
    control,
    errors,
    placeholderText,
    watch,
    clearErrors,
    disabled
}) => {
    const startDate = watch('startDate');
    const endDate = watch('endDate');
    const minDate =
        name === 'expiryDate'
            ? undefined
            : name === 'endDate' && startDate
            ? dayjs(startDate).startOf('day')
            : dayjs().startOf('day');

    useEffect(() => {
        if (startDate && endDate) {
            const start = dayjs(startDate).startOf('day');
            const end = dayjs(endDate).startOf('day');

            // ✅ If valid, clear error messages
            if (start.isBefore(end) || start.isSame(end)) {
                clearErrors('startDate');
                clearErrors('endDate');
            }
        }
    }, [startDate, endDate, clearErrors]);
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
                control={control}
                name={name}
                defaultValue={null}
                rules={{
                    required: `${label.replaceAll('*', '')} is required`,
                    validate: (value) => {
                        if (!value) return true;

                        const today = dayjs().startOf('day');
                        const selected = dayjs(value).startOf('day');

                        // Common rule: cannot select past dates
                        if (
                            name !== 'expiryDate' &&
                            !selected.isAfter(today) &&
                            !selected.isSame(today)
                        ) {
                            return 'Please select a future date';
                        }

                        // Additional check if this is startDate
                        if (name === 'startDate' && endDate) {
                            const end = dayjs(endDate).startOf('day');
                            if (selected.isAfter(end)) {
                                return 'Start date cannot be after end date';
                            }
                        }

                        // Additional check if this is endDate
                        if (name === 'endDate' && startDate) {
                            const start = dayjs(startDate).startOf('day');
                            if (selected.isBefore(start)) {
                                return 'End date cannot be before start date';
                            }
                        }

                        return true;
                    }
                }}
                render={({ field: { value, onChange } }) => (
                    <div className="custom-datepicker">
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={value ? dayjs(value) : null}
                            onChange={(newValue) => {
                                if (newValue) {
                                    const formatted =
                                        dayjs(newValue).format('YYYY-MM-DD');
                                    onChange(formatted);
                                } else {
                                    onChange(null);
                                }
                            }}
                            minDate={minDate}
                            disabled={disabled}
                            slots={{ openPickerIcon: CustomCalendarIcon }} // Custom SVG icon for DatePicker
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    error: !!errors[name],
                                    helperText: errors[name]?.message,
                                    placeholder: placeholderText,
                                    inputProps: {
                                        placeholder: placeholderText,
                                        style: {
                                            backgroundColor: '#fff',
                                            color: '#003764',
                                            boxShadow: 'none'
                                        }
                                    },
                                    sx: {
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                            '& fieldset': {
                                                borderColor: '#ededed', // Custom border color
                                                borderWidth: '1px', // Custom border thickness
                                                borderRadius: '4px'
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#ededed',
                                                borderWidth: '1px' // Thicker border on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#ededed',
                                                borderWidth: '1px' // Thicker border on focus
                                            },
                                            '&.Mui-error fieldset': {
                                                borderColor:
                                                    '#ededed !important'
                                            },
                                            paddingRight: 0
                                        },
                                        '& .MuiInputBase-input': {
                                            backgroundColor: '#fff',
                                            borderRadius: 0,
                                            padding: '9px',
                                            fontSize: '16px', // Customize font size if needed
                                            color: '#003764', // Custom font color
                                            lineHeight: '19px'
                                        },
                                        '& .MuiInputBase-input::placeholder': {
                                            color: '#c9c9c9', // Custom placeholder color
                                            opacity: 1 // Ensure full visibility
                                        },
                                        '& .MuiFormHelperText-root': {
                                            color: '#dc3545 !important', // Change text color
                                            fontSize: '13px', // Adjust font size
                                            lineHeight: '17px',
                                            marginTop: '4px', // Adjust spacing
                                            marginLeft: 0
                                        }
                                    }
                                }
                            }}
                        />
                    </div>
                )}
            />
        </LocalizationProvider>
    );
};

export default DatePickerComponent;

